<template>
  <v-menu
    v-if="$vuetify.breakpoint.smAndDown"
    bottom
    min-width="200px"
    rounded
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list-item-content class="justify-center py-0">
        <div class="mx-auto text-center">
          <router-link class="text-decoration-none" :to="{ name: 'news' }">
            <v-btn depressed text block large>
              <v-icon left>$mdi-newspaper</v-icon>
              {{ $t("layout.navbar.news") }}
            </v-btn>
          </router-link>

          <router-link class="register text-decoration-none" :to="registerLink">
            <v-btn
              class="primary"
              block
              large
              text
              tile
              :ripple="false"
              :disabled="!isOpen"
              >{{ $t("layout.navbar.register") }}</v-btn
            >
          </router-link>
        </div>
      </v-list-item-content>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  computed: {
    isOpen() {
      return this.$store.state.pars.isOpen;
    },

    registerLink() {
      if (!this.isOpen) return { name: "index" };
      return { name: "register" };
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration-line: none;

  .v-btn {
    font-size: 15px;
    color: #7e7e7e;
    text-transform: none;
    letter-spacing: -0.03em;

    .v-icon {
      width: 24px;
    }

    &:hover {
      color: #37b34a;
    }
  }

  &.router-link-active {
    .v-btn {
      color: #008a15;
    }
  }

  &.register {
    .v-btn {
      font-weight: 700;
      letter-spacing: 0.0892857143em;

      &.disabled {
        cursor: not-allowed;
      }

      &:hover {
        color: #ffffff;
      }
    }
  }
}
</style>
